import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidCategoriseYesNo } from '../../../../../mechanics/rid-categorise-yes-no/rid-categorise-yes-no';

@Component({
  selector: 'app-yes-no-audio-page',
  imports: [RidCategoriseYesNo],
  templateUrl: './yes-no-audio-page.html',
})
export class YesNoAudioPage {
  protected readonly $router = inject(Router);
}
